import React from 'react';
import PropTypes from 'prop-types';
import SvgImg from '../../components/Svg/SvgImg';

/* eslint-disable indent */
/* eslint-disable max-len */

const ZoomIcon = (
  {
    width,
    height,
    fill,
  },
) => (
  <SvgImg width={width} height={height} viewbox="0 0 43.09 43.64" title="search">
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_1-2" data-name="Calque 1" fill={fill}>
        <path d="M42.51,40.28,30.17,27.94a17.26,17.26,0,1,0-2.86,2.71L39.73,43.06a2,2,0,1,0,2.78-2.78ZM25.14,28.47A14,14,0,1,1,28,25.76" />
      </g>
    </g>
  </SvgImg>
  );

ZoomIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
};
ZoomIcon.defaultProps = {
  fill: '#828282',
  width: undefined,
  height: undefined,
};
export default ZoomIcon;
